import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, Phone, X } from "lucide-react";
import { ShieldLogo } from "./ShieldLogo";
import { PHONE, PHONE_TEL, track } from "../lib/api";

const NAV = [
  { label: "Protection", to: "/services" },
  { label: "Supplemental", to: "/services#supplemental" },
  { label: "Life", to: "/services#life" },
  { label: "Health", to: "/services#health" },
  { label: "About", to: "/about" },
  { label: "FAQ", to: "/faq" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  return (
    <header className="sticky top-0 z-50 border-b border-white/10 bg-ink/85 backdrop-blur-xl" onKeyDown={(e) => e.key === "Escape" && setOpen(false)}>
      <a href="#main-content" className="skip-link">Skip to main content</a>
      <div className="mx-auto flex h-[72px] max-w-7xl items-center justify-between gap-4 px-4 sm:px-6">
        <Link to="/" aria-label="Show Me Shield home" onClick={() => setOpen(false)}>
          <ShieldLogo compact />
        </Link>

        <nav className="hidden items-center gap-6 lg:flex" aria-label="Primary">
          {NAV.map((item) => (
            <Link
              key={item.label}
              to={item.to}
              data-testid={`nav-${item.label.toLowerCase()}`}
              className={`font-display text-sm font-semibold uppercase tracking-wider transition-colors duration-200 hover:text-lime ${
                pathname === item.to.split("#")[0] && item.to === "/services"
                  ? pathname === "/services"
                    ? "text-lime"
                    : "text-zinc-300"
                  : pathname === item.to
                    ? "text-lime"
                    : "text-zinc-300"
              }`}
            >
              {item.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href={PHONE_TEL}
            data-testid="header-phone-link"
            onClick={() => track("phone_click", { location: "header" })}
            className="hidden items-center gap-2 font-mono text-sm font-bold text-white transition-colors hover:text-lime xl:flex"
          >
            <Phone className="h-4 w-4 text-lime" />
            {PHONE}
          </a>
          <Link
            to="/contact"
            data-testid="header-cta-talk-button"
            onClick={() => track("talk_cta_click", { location: "header" })}
            className="btn-lime hidden !px-5 !py-2.5 text-sm sm:inline-flex"
          >
            Let&apos;s Talk
          </Link>
          <button
            data-testid="header-mobile-menu-button"
            onClick={() => setOpen(!open)}
            aria-label={open ? "Close menu" : "Open menu"}
            aria-expanded={open}
            className="flex h-11 w-11 items-center justify-center rounded-sm border border-line text-white lg:hidden"
          >
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>

      {open && (
        <nav
          data-testid="mobile-nav-panel"
          className="border-t border-line bg-ink px-4 pb-6 pt-2 lg:hidden"
          aria-label="Mobile"
        >
          {[...NAV, { label: "Contact", to: "/contact" }].map((item) => (
            <Link
              key={item.label}
              to={item.to}
              onClick={() => setOpen(false)}
              className="block border-b border-line/60 py-3.5 font-display text-lg font-semibold uppercase tracking-wider text-zinc-200 transition-colors hover:text-lime"
            >
              {item.label}
            </Link>
          ))}
          <a
            href={PHONE_TEL}
            onClick={() => track("phone_click", { location: "mobile_menu" })}
            className="mt-4 flex items-center justify-center gap-2 rounded-sm border border-lime/50 py-3.5 font-mono text-base font-bold text-lime"
          >
            <Phone className="h-4 w-4" /> {PHONE}
          </a>
        </nav>
      )}
    </header>
  );
};
